<template>
  <b-table 
    class="mt-2 mb-0"
    hover 
    striped
    sort-icon-left
    :items="splitGrams" 
    :fields="tableFields">

    <div slot="leftCol" slot-scope="item">
      <div>{{ item.value }}</div>
    </div>

    <div slot="rightCol" slot-scope="item">
      <div>{{ item.value }}</div>
    </div>

  </b-table>
</template>

<script>


export default {
  name: 'grams-table',
  inheritAttrs: false,
  props: {
    grams: {
      type: Array,
      required: true
    },
    numbered: {
      type: Boolean,
      default: false
    },
    maxRows: {
      type: Number,
      default: 5
    }
  },
  data: () => {
    return {

      tableFields: {
        leftCol: {
          label: 'Phrase',
          thStyle: {
            display: 'none'
          }
        },
        rightCol: {
          label: 'Phrase',
          thStyle: {
            display: 'none'
          }
        }
      },
    }
  },
  computed: {
    splitGrams() {
      let leftCol = new Array()
      let rightCol = new Array()

      // split the grams up into 2 columns
      for(let i=0; i<this.grams.length; i++) {
        let s = this.grams[i]
        if(this.numbered) {
          s = (i+1).toString() + '. ' + s
        }

        if(i % 2 == 0) {
          leftCol.push(s)
        } else {
          rightCol.push(s)
        }

        if(rightCol.length >= this.maxRows) {
          break
        }
      }

      let tableRows = []
      for(let i=0; i<leftCol.length; i++) {
        let rightVal = ''
        try {
          rightVal = rightCol[i]
        } catch(error) {
          // use default ''
        }
        tableRows.push({
          'leftCol': leftCol[i],
          'rightCol': rightVal
        })
      }
      return tableRows
    }
  },
  methods: {

  }
}
</script>
